// Per rule: code-comments-required (ai.knowledge/global) — explain why.
// Per rule: reference-rules-in-comments (ai.knowledge/global) — name the rules.
//
// Billing shows "Standard trial, ends <date>" while a Studio is on
// the no-card Standard trial. The backend reports the deadline as
// BillingRegistryGetRoomBillingInfoResponse.trialEnd (Unix seconds, 0 when
// not on a trial). Kept as a pure function so the copy and the "0 means no
// trial" contract are unit-tested without React scaffolding, the same way
// billing-response-helpers.ts is.

import { dayjs } from '@studio/js-utils/time';

/**
 * The trial end as a Date, or undefined when the Studio is not on a trial.
 * `0`/`undefined` both mean "no trial": an older backend that predates the
 * field reads as undefined, and the field's zero value is the explicit
 * "not trialing" answer. Per rule: absent-data-gates-permissively
 * (ai.knowledge/global) — missing data never fabricates a trial notice.
 */
export const standardTrialEndDate = (trialEnd: number | undefined): Date | undefined => {
  if (trialEnd === undefined || trialEnd <= 0) {
    return undefined;
  }
  return dayjs(trialEnd * 1000).toDate();
};

/** The exact Billing copy for a live trial: "Standard trial, ends M/D/YYYY". */
export const standardTrialLabel = (trialEndsAt: Date): string =>
  `Standard trial, ends ${dayjs(trialEndsAt).format('M/D/YYYY')}`;
